import { useReframe } from 'nike-re-framejs';
import { hasSportsMarketStats$ } from '../reframe/h&s';

const useMarketStatsAvailable: (sportId: string) => boolean = sportId => {
    const derefSub = useReframe();
    const sportHasMarketStats = derefSub(hasSportsMarketStats$);
    return sportHasMarketStats?.includes(parseInt(sportId));
};
export default useMarketStatsAvailable;
